import { ContactInfo } from '../common/ContactInfo';

export function ADF_MyAccount() {
  return <ContactInfo />;
}
